<h4 class="font-app-bold text-darkest text-sm md:text-base">
  {{ "optionsList.medicalHistory" | translate }}
</h4>
<div class="mt-4 flex flex-col gap-4">
  <div class="flex items-end">
    <div class="items-center justify-between w-full">
      <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
        "optionsList.hasHistory" | translate
      }}</span>
    </div>
    <span class="text-sm md:text-base font-app-bold text-darkest">
      {{ (hasHistory ? "logout.confirm" : "logout.cancel") | translate }}</span
    >
  </div>

  @if (hasHistory) {
    <div
      class="flex items-end mt-2"
      *ngFor="let item of illnesses; let i = index">
      <div class="items-center justify-between w-full">
        <span class="font-app-regular text-dark text-sm md:text-base col-start-1">{{
          "optionsList.illness" | translate: { index: i + 1 }
        }}</span>
      </div>
      <span class="text-sm md:text-base font-app-bold text-darkest"> {{ item | titlecase }}</span>
    </div>
  }
</div>
